const categories = [
  {
    id: 'reunion',
    nameKey: 'cat_reunion',
    icon: '💕',
    color: '#ff6b6b',
    requiresPartner: true,
    requiresBirthInfo: true
  },
  {
    id: 'marriage',
    nameKey: 'cat_marriage',
    icon: '👰',
    color: '#74b9ff',
    requiresPartner: true,
    requiresBirthInfo: true
  },
  {
    id: 'love',
    nameKey: 'cat_love',
    icon: '❤️',
    color: '#ff7675',
    requiresPartner: true,
    requiresBirthInfo: true
  },
  {
    id: 'compatibility',
    nameKey: 'cat_compatibility',
    icon: '💙',
    color: '#0984e3',
    requiresPartner: true,
    requiresBirthInfo: true
  },
  {
    id: 'newyear',
    nameKey: 'cat_newyear',
    icon: '🧧',
    color: '#e17055',
    requiresPartner: false,
    requiresBirthInfo: true
  },
  {
    id: 'career',
    nameKey: 'cat_career',
    icon: '💼',
    color: '#6c5ce7',
    requiresPartner: false,
    requiresBirthInfo: true
  },
  {
    id: 'wealth',
    nameKey: 'cat_wealth',
    icon: '💵',
    color: '#00cec9',
    requiresPartner: false,
    requiresBirthInfo: true
  }
];

export default categories;
